import { AuthMachineInterpreter } from './authMachine'
import { IAuthMachine } from './symbols'

export async function getAuthService() {
  const { authContainer } = await import(
    /* webpackChunkName: "auth-inversify", webpackMode: "lazy" */ './inversify.config'
  )
  return authContainer.get<AuthMachineInterpreter>(IAuthMachine)
}
